module.exports = __webpack_public_path__ + "img/pr.de4f37a4.png";